<template>
  <div>
    <div class="row">
      <div class="col-12">
        <Card body-classes="p-0" class="mb-5 bg-white shadow-sm">
          <template v-slot:header>
            <div class="d-flex align-items-center justify-content-between p-2">
              <div class="d-flex align-items-center">
                <div class="bg-primary-light p-2 rounded-2 me-3">
                  <vue-feather type="user-plus" class="d-flex justify-content-center align-content-center" stroke="#652aa3" size="24"></vue-feather>
                </div>
                <h4 class="mb-0 fw-bold">Add Casual</h4>
              </div>
            </div>
          </template>
          <div class="col-md-12 p-4">
            <form @submit.prevent="">
              <!-- Personal Information Section -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="user" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Personal Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-3">
                      <label for="casual_no" class="form-label fw-bold">Casual No:</label>
                      <input type="text" class="form-control" placeholder="Casual No" v-model="casual.casual_no" readonly>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="first_name" class="form-label fw-bold">First Name:</label>
                      <input type="text" class="form-control" placeholder="First Name" v-model="casual.first_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="middle_name" class="form-label fw-bold">Middle Name: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" placeholder="Middle Name" v-model="casual.middle_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="last_name" class="form-label fw-bold">Last Name:</label>
                      <input type="text" class="form-control" placeholder="Last Name" v-model="casual.last_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="id_number" class="form-label fw-bold">ID Number:</label>
                      <input type="text" class="form-control" placeholder="ID Number" v-model="casual.id_number">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="phone" class="form-label fw-bold">Phone:</label>
                      <input type="text" class="form-control" placeholder="0712333555" v-model="casual.phone">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="gender" class="form-label fw-bold">Gender:</label>
                      <select data="" type="text" class="form-select" v-model="casual.gender">
                        <option value="" disabled selected>Select gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="dob" class="form-label fw-bold">Date of Birth:</label>
                      <input type="date" class="form-control" v-model="casual.dob">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="address" class="form-label fw-bold">Address:</label>
                      <input type="text" class="form-control" placeholder="Address" v-model="casual.address">
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Employment Information -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="briefcase" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Employment Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-4">
                      <label for="salary" class="form-label fw-bold">Daily Pay Amount:</label>
                      <input type="number" class="form-control" placeholder="Daily Pay" v-model="casual.pay">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="employment_date" class="form-label fw-bold">Employment Date:</label>
                      <input type="date" class="form-control" v-model="casual.employment_date">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="duty" class="form-label fw-bold">Duty: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <textarea class="form-control" v-model="casual.duty" rows="2"></textarea>
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Work Information -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="layers" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Work Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-6">
                      <label for="department" class="form-label fw-bold">Department:</label>
                      <div class="input-group">
                        <select data="" type="text" class="form-select" v-model="casual.department_id">
                          <option value="" disabled selected>Select department</option>
                          <option v-for="department in departments" :key="department.id" :value="department.id">{{department.name}}</option>
                        </select>
                        <button type="button" class="btn btn-outline-primary" @click="addDepartment">
                          <vue-feather type="plus" size="16"></vue-feather>
                        </button>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="work_station" class="form-label fw-bold">Work Station:</label>
                      <div class="input-group">
                        <select data="" type="text" class="form-select" v-model="casual.work_station_id">
                          <option value="" disabled selected>Select work station</option>
                          <option v-for="station in stations" :key="station.id" :value="station.id">{{station.name}}</option>
                        </select>
                        <button type="button" class="btn btn-outline-primary" @click="addStation">
                          <vue-feather type="plus" size="16"></vue-feather>
                        </button>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </form>
          </div>
          <div class="p-4 bg-light border-top">
            <div class="d-flex justify-content-center">
              <button class="btn btn-dark text-uppercase me-4 px-4 py-2 shadow" @click="$router.go(-1)">
                <vue-feather type="arrow-left" size="16" class="me-2"></vue-feather>
                Back
              </button>
              <button v-if="permissions.includes('create casuals')" class="btn btn-primary text-uppercase px-4 py-2 shadow" @click="submitForm">
                <vue-feather type="save" size="16" class="me-2"></vue-feather>
                Submit
              </button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import casualService from "@/api/casualService";
import departmentService from "@/api/departmentService";
import stationService from "@/api/stationService";
import router from "@/router";
import {decrypt} from "@/utils/crypto";
import loadingButton from "@/utils/loadingButton";
import VueFeather from 'vue-feather';

export default {
  name: "AddCasual",
  components: {
    VueFeather
  },
  data() {
    return {
      departments: [],
      stations: [],
      permissions: [],
      casual: {
        casual_no: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        id_number: '',
        phone: '',
        gender: '',
        dob: '',
        address: '',
        pay: '',
        duty: '',
        status: '',
        employment_date: '',
        termination_date: '',
        department_id: '',
        work_station_id: '',
      },
      profile: {},
      nextNo: {},
    }
  },
  methods: {
    submitForm: async function (e) {
      loadingButton(e)
      await casualService.createCasual(this.casual)
      loadingButton(e, false)
    },
    addDepartment: function () {
      router.push({
        path: 'departments',
        query: { add: 'true' }
      })
    },
    addStation: function () {
      router.push({
        path: 'work-stations',
        query: { add: 'true' }
      })
    },
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    this.permissions = this.profile.permissionNames
    this.nextNo = await casualService.getCasualNextNo()
    this.casual.casual_no = this.nextNo.next
    this.departments = await departmentService.getDepartments()
    this.stations = await stationService.getStations()
  },
}
</script>

<style scoped>

</style>
